<template>
  <div class="skeletonView"  @touchmove.prevent @mousewheel.prevent>
    <div class="swiper">
      <div class="point">
        <i class="item" v-for="(item,i) in 3" :key="i"></i>
      </div>
    </div>
    <!--  -->
    <div class="center">
      <div class="title"></div>
      <div class="number">
        <div class="item" v-for="(item,i) in 3" :key="i"></div>
      </div>
      <div class="count"></div>
    </div>
    <div class="btn">
      <div class="item" v-for="(item,i) in 2" :key="i"></div>
    </div>
    <div class="player">
      <div class="item" v-for="(item,i) in 2" :key="i"></div>
    </div>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="less" scoped>
@keyframes light {
  0% {
    background: #f8f8f8;
  }
  50% {
    background: #f2f3f5;
  }
  100% {
    background: #f8f8f8;
  }
}
@keyframes bgfff {
  0% {
    background: #fff;
  }
  50% {
    background: #fff;
    opacity: 0.8;
  }
  100% {
    background: #fff;
  }
}
.skeletonView{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin:0 auto;
  z-index: 9999;
  background: #fff;
  div.swiper{
    width: 100%;
    height: 50%;
    background: #f2f3f5;
    animation: light 1.2s ease-in-out infinite;
    position: relative;
    .point{
      position: absolute;
      z-index: 9999;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .item{
        display: inline-block;
        width: .2666667rem;
        height: .2666667rem;
        background: #fff;
        border-radius: 50%;
        margin: 0 5px;
      }
    }

  }
  div.center{
    width: 92%;
    // height: 30rem;
    margin: .4rem auto;
    border: 1px solid #f2f3f5;
    box-sizing: border-box;
    padding: .5rem .2666667rem;
    .title{
      width: 100%;
      height: .8rem;
      background:#f2f3f5;
      animation: light 1.2s ease-in-out infinite;
    }
    .number{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: .2666667rem 0;
      div.item{
        flex: 1;
        height: 1.5rem;
        background:#f2f3f5;
        animation: light 1.2s ease-in-out infinite;
      }
      div.item:nth-child(2){
        margin: 0 .5333333rem;
      }
    }
    .count{
      width: 80%;
      height: .8rem;
      background:#f2f3f5;
      margin: auto;
      animation: light 1.2s ease-in-out infinite;
    }
  }
  div.btn{
    width: 88%;
    margin:.5333333rem auto ;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item{
      width: 45%;
      height: .8rem;
      background:#f2f3f5;
      animation: light 1.2s ease-in-out infinite;
    }
  }
  div.player{
    width: 92%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item{
      width: 45%;
      min-height: 3.5rem;
      max-height: 5.0rem;
      background:#f2f3f5;
      animation: light 1.2s ease-in-out infinite;
    }
  }
}
</style>